// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"16b71c30","373":"5ca8e498","513":"214db308","642":"dcbd53ce","659":"6fd9ebea","739":"2fdb0e79"}[chunkId] + ".chunk.js";
};